import { AxiosResponse } from 'axios';
import { ApiService } from '../api/axios';

export class CheckIntegrationService {
	async fetchIDAustriaLogin(): Promise<AxiosResponse> {
		const res = await ApiService.post('/ida/login');
		window.location.href = res.data.redirectURL;
		return res;
	}
}

export const checkIntegrationService = new CheckIntegrationService();
